import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IProjectGroup } from "../../utils/types/models";

export default createEntityReducer<IProjectGroup>(Endpoint.ProjectGroups, Endpoint.ProjectGroupsList);
